import { easeQuadIn } from 'd3-ease';

import {
  ScrollScene,
  globalScrollService,
} from '$app/scrolling/global-scroll-service.js';

class SeriesPageComponent extends HTMLElement {
  connectedCallback() {
    this.scene = new ScrollScene(this.sentinel, {
      easingFunction: easeQuadIn,
      sceneStart: 0,
    });
    this.scene.on('progress', (p) => {
      this.fadingElement.style.opacity = 1 - p;
    });
    this.sceneId = globalScrollService.addScene(this.scene);
  }

  disconnectedCallback() {
    globalScrollService.removeScene(this.sceneId);
  }

  get sentinel() {
    return this.querySelector('[data-sentinel]');
  }

  get fadingElement() {
    return this.querySelector('[data-fade]');
  }
}

if (!window.customElements.get('tmp-series-page')) {
  window.SeriesPageComponent = SeriesPageComponent;
  window.customElements.define('tmp-series-page', SeriesPageComponent);
}
